var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.authorized)?_c('div',[_c('default-bar'),_c('default-drawer'),_c('default-footer')],1):_vm._e(),_c('default-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }